// In milliseconds
export const time = {
  get eighteenYearsAgo() {
    return new Date(new Date().setFullYear(new Date().getFullYear() - 18));
  },
};

interface TimeAgo {
  value: number;
  type: 'seconds' | 'minutes' | 'hours' | 'days' | 'months' | 'years';
}

export function timeAgo(date: Date, now: Date = new Date()): TimeAgo {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    throw new Error('Invalid date provided');
  }

  const diff = now.getTime() - date.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  let months = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());
  if (now.getDate() < date.getDate()) {
    months -= 1;
  }

  const years = Math.floor(months / 12);

  if (years > 0) return { type: 'years', value: years };
  if (months > 0) return { type: 'months', value: months };
  if (days > 0) return { type: 'days', value: days };
  if (hours > 0) return { type: 'hours', value: hours };
  if (minutes > 0) return { type: 'minutes', value: minutes };
  if (seconds > 0) return { type: 'seconds', value: seconds };
  return { type: 'seconds', value: 0 };
}
